export default __webpack_public_path__ + "static/media/avatar_44.5fd4c4e6.png";